export class ToggleRadio {
    constructor(radioEl) {
        this.radioEl = radioEl;
        this.radioButtons = radioEl.querySelectorAll("input[type=radio]");
        this.init();
    }

    init() {
        this.radioButtons.forEach((radio) => {
            radio.addEventListener("change", (event) => {
                this.toggle(event.target);
            });
        });

        const checkedRadio = this.radioEl.querySelector("input[type=radio]:checked");
        if (checkedRadio) {
            this.toggle(checkedRadio);
        }
    }

    toggle(elem) {
        const targetToOpen = document.querySelector(elem.getAttribute("data-radio-toggle-target"));
        const targetToClose = document.querySelector(elem.getAttribute("data-radio-toggle-target-close"));

        if (targetToOpen) {
            targetToOpen.classList.add("active");
        }

        if (targetToClose) {
            targetToClose.classList.remove("active");
        }

        const addActions = document.querySelector(elem.getAttribute("data-add-actions"));
        const removeActions = document.querySelector(elem.getAttribute("data-remove-actions"));

        if (addActions) {
            addActions.style.display = "flex";
        }

        if (removeActions) {
            removeActions.style.display = "none";
        }
    }
}

export class ToggleSection {
    constructor(toggleButton) {
        this.toggleButton = toggleButton;
        this.toggleButton.addEventListener("click", this.toggleActive.bind(this));
    }

    toggleActive() {
        const target = document.querySelector(this.toggleButton.getAttribute("data-toggle-section-target"));
        target.classList.toggle("active");
        this.toggleButton.classList.toggle("active");
    }
}

export class ToggleTab {
    constructor(tab) {
        this.toggleTab = tab;
        this.tabButtons = this.toggleTab.querySelectorAll(".js-toggle-tab-button");
        this.tabSections = this.toggleTab.querySelectorAll(".js-toggle-tab-section");
        this.init();
    }

    init() {
        this.tabButtons.forEach((tabButton) => {
            tabButton.addEventListener("click", () => {
                this.toggleActive(tabButton);
            });
        });
    }

    toggleActive(element) {
        this.tabSections.forEach((tabSection) => {
            tabSection.classList.remove("active");
        });

        this.tabButtons.forEach((tabButton) => {
            tabButton.classList.remove("active");
        });

        const target = document.querySelector(element.getAttribute("data-toggle-tab-target"));
        element.classList.add("active");
        target.classList.add("active");

        if (target.id === "pre-visit") {
            document.querySelector("#questionnaire").classList.remove("active");
        }

        if (target.id === "store-visit" && document.querySelector("input[data-radio-toggle-target= \"#questionnaire\"]:checked")) {
            document.querySelector("#questionnaire").classList.add("active");
        }
    }
}

export class ToggleCheckbox {
    constructor(checkboxEl) {
        this.checkboxEl = checkboxEl;
        this.checkbox = this.checkboxEl.querySelector("input[type=checkbox]");
        this.target = this.checkboxEl.querySelector(".js-toggle-checkbox-target");
        this.init();
    }

    init() {
        const checkedElem = this.checkboxEl.querySelector("input[type=checkbox]:checked");
        if (checkedElem) {
            this.target.classList.toggle("active");
        }

        this.checkbox.addEventListener("change", () => {
            this.target.classList.toggle("active");
        });
    }
}

export class VerticalMenu {
    constructor(menu, menusLists) {
        menu.addEventListener("click", (event) => {
            menusLists.forEach(element => element.classList.add("d-n"));
            if (event.target.querySelector(".vertical-menu-list")) {
                event.target.querySelector(".vertical-menu-list").classList.toggle("d-n");
            }
        });
    }
}

export class Toggle {
    // constructor () {}

    radio() {
        document.querySelectorAll(".js-toggle-radio").forEach((radioEl) => {
            // TODO: find a way to fix this eslint rule here
            new ToggleRadio(radioEl); // eslint-disable-line no-new
        });
    }

    section() {
        document.querySelectorAll(".js-toggle-section-button").forEach((btn) => {
            // TODO: find a way to fix this eslint rule here
            new ToggleSection(btn); // eslint-disable-line no-new
        });
    }

    tab() {
        document.querySelectorAll(".js-toggle-tab").forEach((tab) => {
            // TODO: find a way to fix this eslint rule here
            new ToggleTab(tab); // eslint-disable-line no-new
        });
    }

    checkbox() {
        document.querySelectorAll(".js-toggle-checkbox").forEach((checkboxEl) => {
            // TODO: find a way to fix this eslint rule here
            new ToggleCheckbox(checkboxEl); // eslint-disable-line no-new
        });
    }

    verticalMenu() {
        const menus = document.querySelectorAll(".vertical-menu");
        const menusLists = document.querySelectorAll(".vertical-menu-list");

        if (menus) {
            document.querySelector("body").addEventListener("click", (event) => {
                const targetClassList = event.target.classList;
                if (!targetClassList.contains("vertical-menu") && !targetClassList.contains("vertical-menu-list")) {
                    menusLists.forEach(element => element.classList.add("d-n"));
                }
            });
            menus.forEach((menu) => {
                // TODO: find a way to fix this eslint rule here
                new VerticalMenu(menu, menusLists); // eslint-disable-line no-new
            });
        }
    }

    all() {
        this.radio();
        this.section();
        this.tab();
        this.checkbox();
        this.verticalMenu();
    }
}
